module.exports = __webpack_public_path__ + "img/lr2.0c743d48.png";